module.exports = __webpack_public_path__ + "static/media/TeamRed.a724b7fc.png";